import ApiConnection from "./connection";

const registerUserPatient = async (userData, token) => {
  try {
    const response = await ApiConnection.post(
      "user-patients/register",
      userData,
      {
        headers: { Authorization: `Bearer ${token}` },
      },
    );

    return response.data; // Retorna os dados da resposta se bem-sucedido
  } catch (error) {
    const errorMessage =
      error.response?.data?.error || "Erro ao cadastrar paciente";
    throw new Error(errorMessage); // Lança um erro com a mensagem apropriada
  }
};

const VerificarCpf = async (cleanCpf) => {
  try {
    // Envia o CPF no formato correto
    const response = await ApiConnection.post("user-patients/cpf-exists", {
      CPF: cleanCpf,
    });
    return {
      output: response.data,
      status: response.status,
      message: response.data.message,
    };
  } catch (e) {
    return {
      status: e.response.status,
      message: e.response.data.message,
      data: e.response.data,
    };
  }
};

const getUserByCpf = async (cpf) => {
  if (cpf.trim() === "") {
    return {};
  }

  try {
    const response = await ApiConnection.post("user-patients/get-by-cpf", {
      cpf,
    });
    return {
      output: response.data,
      status: response.status,
      message: response.data?.message || "OK",
    };
  } catch (error) {
    // Mesmo em erro, retorna status e mensagem
    return {
      output: error.response?.data || null,
      status: error.response?.status || 500,
      message: error.response?.data?.message || "Erro ao buscar usuário",
    };
  }
};

const ban = async (token, id_user, username) => {
  try {
    const response = await ApiConnection.put(
      `user-patients/${id_user}/${username}/ban`,
      {},
      { headers: { Authorization: `Bearer ${token}` } },
    );
    return { output: response.data, status: response.status };
  } catch (e) {
    return { status: e.response?.status };
  }
};

const remove = async (token, id_user, id_categoria, username, name, justificativa) => {

  try {
    const response = await ApiConnection.put(
      `user-patients/${id_user}/${id_categoria}/${username}/${name}/${justificativa}/remove`,
      {},
      { headers: { Authorization: `Bearer ${token}` } },
    );
    return { output: response.data, status: response.status };
  } catch (e) {
    return { status: e.response?.status };
  }
};

const update = async (token, userData) => {
  try {
    const response = await ApiConnection.put(`user-patients/update`, userData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return { output: response.data, status: response.status };
  } catch (e) {
    return { status: e.response.status };
  }
};

const getByUser = async (token, userID) =>
  ApiConnection.get(`user-patients/${userID}`, {
    headers: { Authorization: `Bearer ${token}` },
  })
    .then((response) => {
      return { output: response.data, status: response.status };
    })
    .catch((e) => {
      return { status: e.response.status };
    });

export default function user() {
  return {
    registerUserPatient,
    VerificarCpf,
    getUserByCpf,
    getByUser,
    update,
    remove,
    ban,
  };
}
